import { v4 } from "uuid";
import * as __rspack_external__cookies_js_7d374091 from "../cookies.js";
const DISTINCT_ID_KEY = 'session_distinct_id';
function getUserDistinctId() {
    const distinctId = __rspack_external__cookies_js_7d374091.getAll()[DISTINCT_ID_KEY];
    if (distinctId) return {
        distinctId,
        wasRecentlyCreated: false
    };
    const newDistinctId = v4();
    __rspack_external__cookies_js_7d374091.setCookie(DISTINCT_ID_KEY, newDistinctId, 365);
    window.distinctUserIdWasRecentlyCreated = true;
    return {
        distinctId: newDistinctId,
        wasRecentlyCreated: true
    };
}
const getUserDistinctId_getUserDistinctId = getUserDistinctId;
export default getUserDistinctId_getUserDistinctId;
export { DISTINCT_ID_KEY };
